import { useRef } from 'react'

/**
 * A react ref object
 * @typedef {Object} Ref
 * @property {any} current - any value currently assigned to the ref
 */

/** tiny convience hook - will define a new ref, if no ref is passed
 *
 * @param {Ref} ref - ref object to use
 * @param {*} initialValue - default value to use for the new ref
 * @returns {Ref} a ref object
 */
export function useFallbackRef(ref, initialValue) {
    const fallbackRef = useRef(initialValue)

    return ref ?? fallbackRef
}
